import { Icon } from '@toggle/design-system';
import { CatalystInsight } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PosthogTrackingSource } from '~/services/tracking/posthog/constants';
import { getCatalystInsightIconProps } from '~/widgets/catalyst-insights-drawer/catalyst-insight-icon/utils';
import { useCatalystDrawer } from '~/widgets/catalyst-insights-drawer/useCatalystDrawer';

import * as S from './CompanyCatalystCounterTooltip.styles';

interface CompanyCatalystCounterTooltipProps {
  insights: CatalystInsight[];
  source: PosthogTrackingSource;
  onClose?: () => void;
}

export const CompanyCatalystCounterTooltip = ({
  insights,
  source,
  onClose,
}: CompanyCatalystCounterTooltipProps) => {
  const { t } = useTranslation(['insights']);
  const { openDrawer } = useCatalystDrawer();

  const iconProps = getCatalystInsightIconProps({
    isBordered: true,
    isCompanyCatalyst: true,
  });
  return (
    <div onClick={e => e.stopPropagation()}>
      {insights.map(insight => {
        const entityTag = insight.identifier;
        return (
          <S.TooltipWrapper
            key={insight.id}
            onClick={() => {
              if (entityTag) {
                openDrawer({
                  type: 'company',
                  entityTag,
                  insightId: insight.id,
                  source,
                });
                onClose?.();
              }
            }}
          >
            <Icon {...iconProps} size={32} />
            <S.RightWrapper>
              <S.TooltipTitleLabel>
                {t('insights:catalyst.titleCompanyCatalyst')}
              </S.TooltipTitleLabel>
              <S.CategoryLabel>
                {/* i18next-extract-mark-context-next-line ["financial_operational_updates", "corporate_actions_strategic_announcements", "management_leadership_changes", "legal_regulatory_events"] */}
                {t(`catalyst.subcategories.${insight.sub_category}`)}
              </S.CategoryLabel>
            </S.RightWrapper>
          </S.TooltipWrapper>
        );
      })}
    </div>
  );
};
